import React from 'react';
import Immutable from 'immutable';
import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  PARAGRAPH_VIEW_MODE_FULLSCREEN,
} from '../../../../config/constants';

import AnnualReportThemeHero from '../../../../components/AnnualReportThemeHero';

import '../style.scss';

const AnnualReportThemeDetail = ({ entity }) => {
  const colorVariant = entity.getIn(['field_color_variant', 0, 'value'], '');
  const paragraphs = entity.get('field_paragraphs', Immutable.List());

  return (
    <article className={`AnnualReportTheme AnnualReportTheme--${colorVariant}`}>
      <AnnualReportThemeHero
        entity={entity}
        withLink={false}
      />

      {/* Start of paragraphs */}
      {paragraphs.size > 0 ? (
        <div className="node--page--paragraphs-wrapper">
          {paragraphs.map((paragraph) => {
            const id = paragraph.get('target_id');
            return (
              <Paragraph
                key={`paragraph:${id}`}
                id={id}
                entity={paragraph.get('entity')}
                viewMode={PARAGRAPH_VIEW_MODE_FULLSCREEN}
              />
            );
          })}
        </div>
      ) : null}
      {/* End of paragraphs */}
    </article>
  );
};

export default AnnualReportThemeDetail;
